
















import { Component, Vue } from 'vue-property-decorator';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';

@Component
export default class MobileLoginErrorDialog extends Vue {
    private goBack() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.LogIn,
            viewMode: ViewModes.LogIn.LogInView,
        });

        if (this.getResponseCode === 422) {
            this.$store.commit(Mutations.SET_PIN_INPUT, []);
        }

        this.$store.commit(Mutations.UPDATE_RESPONSE_CODE, null);
    }

    get getResponseCode(): number {
        return this.$store.getters['User/getResponseCode'];
    }

    get responseCodeMessage(): string {
        return this.$store.getters['User/getResponseCodeMessage'];
    }
}
